import type { FaireProductEntity } from "../../entity_types/product";

export const p_8bnr7kd9yg: FaireProductEntity = {
  token: "p_8bnr7kd9yg",
  type: "product",
  name: "Mini Halloween Skull Candle Raw Sugar, Clove & Sandalwood",
  brandToken: "b_8tj4junats",
  brandName: "Effing Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/633a152d97c5e5c0952c54cc22b976f01635a50c79d2f2c751b6300695bb8b68.png",
  galleryImageUrls: [],
  priceDollars: 7.5,
  description:
    'Get in the spirit of spooky season with our mini Halloween Skull Candle! This candle, featuring a raw sugar, clove, and sandalwood scent, will transport you to cozy nights, falling leaves, and all things Halloween. Perfect for setting the mood or adding a touch of quirk to your decor. When the candle is done burning, the glass can be cleaned and the container can be used as a shot glass or espresso cup. \n\nMade with all-natural apricot coconut wax, fine fragrance and essential oils, and an FSC-Certified crackling wooden wick for maximum cozy vibes. \n\nWeight: 2.5oz\nDimensions Small: 3.75" L x 2.5"W x 3"H\nBurn time: 20 hours \n',
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:42.539Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
